import { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLoginPage() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setError("Please enter both email and password");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const API_BASE = import.meta.env.DEV
        ? "http://localhost:8787"
        : "https://shopglobal-backend-production.finhub.workers.dev";

      const response = await fetch(`${API_BASE}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        // Store admin session
        localStorage.setItem("admin_token", result.token);
        localStorage.setItem("admin_user", JSON.stringify(result.admin));
        navigate("/admin/dashboard");
      } else {
        setError(result.error || "Login failed");
      }
    } catch (error) {
      console.error("Admin login error:", error);
      setError("Failed to connect to server");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center py-8">
      <div className="max-w-md w-full bg-gray-800 rounded-lg shadow-2xl p-8 border border-gray-700">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-orange-600 rounded-lg flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            📦
          </div>
          <h2 className="text-2xl font-bold text-white">Warehouse Access</h2>
          <p className="text-gray-400">ShopGlobal Pro - Warehouse Operations</p>
        </div>

        {error && (
          <div className="bg-red-900/50 border border-red-700 text-red-200 px-4 py-3 rounded-lg mb-6 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Warehouse Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full border border-gray-600 rounded-lg px-3 py-3 bg-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="staff@shopglobal.com"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="w-full border border-gray-600 rounded-lg px-3 py-3 bg-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="Enter password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            {isLoading ? "Accessing..." : "Access Warehouse"}
          </button>
        </form>

        <div className="mt-8 p-4 bg-gray-700/50 rounded-lg">
          <h3 className="text-sm font-medium text-gray-300 mb-3">
            Demo Accounts:
          </h3>
          <div className="space-y-2 text-xs text-gray-400">
            <div>Supervisor: warehouse-lead@shopglobal.com / demo123</div>
            <div>Inspector: inspector-mike@shopglobal.com / demo123</div>
            <div>Receiving: receiving-lisa@shopglobal.com / demo123</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLoginPage;
